<template>
  <div class="BranchForm">
    <el-container class="p-0">
      <el-main>
        <el-form
          ref="form"
          label-width="70px"
          class="form-label-70"
          :model="data"
          :rules="rules"
        >
          <el-form-item prop="name" label="부서명">
            <el-input v-model="data.name" maxlength="25" />
          </el-form-item>
          <el-form-item label="비고">
            <el-input type="textarea" v-model="data.desc" maxlength="100" />
          </el-form-item>
        </el-form>
      </el-main>
      <el-footer>
        <el-button
          type="primary"
          v-shortkey="['f4']"
          :disabled="!has_grant_write"
          :loading="load_button"
          @shortkey.native="handleClickRegister"
          @click="handleClickRegister"
          >{{ is_new ? $t("button.add") : $t("button.modify") }}(F4)</el-button
        >
        <el-button
          type="danger"
          v-if="!is_new"
          :disabled="!has_grant_write"
          :loading="load_button"
          @click="handleClickDelete"
          >{{ $t("button.delete") }}</el-button
        >
        <el-button class="close-button" @click="closeDialog"
          >{{ $t("button.close") }}(Esc)</el-button
        >
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import { form } from "@/common/mixins/form";

export default {
  name: "BranchForm",
  mixins: [form],
  data() {
    return {
      title: this.$t("title.branch"),
      rules: {
        name: [
          {
            required: true,
            message: "부서명을 입력해 주세요.",
            trigger: "blur",
          },
        ],
      },
      load_button: false,
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          name: "",
          desc: "",
        };
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    is_new: function() {
      return this.data.id < 1;
    },
  },
  methods: {
    /** Add or modify data */
    doRegister() {
      let api = this.is_new ? this.api.createBranch : this.api.updateBranch;
      let message = this.is_new
        ? this.$t("message.success_create")
        : this.$t("message.success_update");
      this.load_button = true;
      api(this.data).then((res) => {
        this.load_button = false;
        this.handleResult(res, message);
      });
    },
    /**Delete data */
    doDelete() {
      this.load_button = true;
      this.api.deleteBranch(this.data).then((res) => {
        this.load_button = false;
        this.handleResult(res, this.$t("message.success_delete"));
      });
    },
    /**Click the Modify button */
    handleClickRegister() {
      if (!this.has_grant_write) return;

      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.doRegister();
      });
    },
    /**Click Delete button */
    handleClickDelete() {
      this.util.confirm_delete(
        this,
        this.title + "[" + this.data.name + "]",
        this.doDelete
      );
    },
    handleResult(res, successMessage) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, successMessage);
      this.$emit("completed", true);
    },
  },
};
</script>
